// extracted by mini-css-extract-plugin
export default {"notes":"notes_notes__p-4-b","activeNotes":"notes_activeNotes__-6HZi","historyNotes":"notes_historyNotes__FCJwK","body":"notes_body__UYWC1","filters":"notes_filters__dczFu"};